import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";
import _ from "lodash";
//import _ from 'lodash';

class AgenciesSearch extends Component {
	render() {
		const { amounts_agencies, modalities, versions } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>

			<div className="control">
				<div className={`select is-small${modalities.isFetching ? ' is-loading' : ''}`}>
					<select name="modality_id" id="modality_id" value={amounts_agencies.filters.modality_id} onChange={this._modalityChange} disabled={modalities.isFetching}>
						<option value="">--- Modalidad ---</option>
						{_.map(modalities.list, (row, k) => {
							return (
								<option key={k} value={row.id}>{row.name}</option>
							)
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<div className={`select is-small${versions.isFetching ? ' is-loading' : ''}`}>
					<select name="version_id" id="version_id" disabled={versions.isFetching} value={amounts_agencies.filters.version_id} onChange={this._versionChange}>
						<option value=" " defaultValue>--- Año ---</option>
						{_.map(versions.list,(version, k) => {
							return <option value={version.id} key={k}>{version.year}</option>
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={amounts_agencies.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._modalityChange = this._modalityChange.bind(this);
		this._versionChange = this._versionChange.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	componentWillMount() {
		this.props.fetchModalities();
		this.props.versionsList();
	}

	_submitSearch() {
		const {amounts_agencies} = this.props;
		this.props.amountsAgenciesShow(1,amounts_agencies.filters);
	}

	_modalityChange(event){
		this.props.change('amounts_agencies.filters.modality_id',event.target.value);
	}

	_versionChange(event){
		this.props.change('amounts_agencies.filters.version_id',event.target.value);
	}

	_searchChange(event){
		this.props.change('amounts_agencies.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('amounts_agencies.filters');
		this.props.amountsAgenciesShow(1);
	}
}

export default SecureLayout(AgenciesSearch);



// WEBPACK FOOTER //
// ./src/elements/agencies/widget/amounts_search.jsx